<template>
  <div class="pix-choice-user">
    <p class="pix-choice-user__title">{{ title }}</p>
    <p class="pix-choice-user__subtitle">
      {{ subtitle }}
    </p>

    <div v-if="content" class="pix-choice-user__select">
      <div
        v-for="owner in content"
        class="pix-choice-user__item"
        :key="owner.cpf"
        :class="{
          'pix-choice-user__item-selected': owner.cpf === chosenOwner?.cpf,
        }"
        @click="selectedAccount(owner)"
      >
        <div class="pix-choice-user__item--bullet bullet-selected">
          <div class="selected"></div>
        </div>
        <div class="pix-choice-user__item--content">
          <p class="pix-choice-user__item--name">{{ owner.name }}</p>
          <p class="pix-choice-user__item--cpf">{{ owner.cpf }}</p>
        </div>
      </div>

      <div class="pix-choice-user__button" v-if="withdraw">
        <button
          :disabled="!this.chosenOwner"
          class="button is-support is-big"
          type="submit"
          @click="accountSubmit()"
        >
          Avançar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    content: {
      type: Array,
      required: true,
    },
    withdraw: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    chosenOwner: {
      get() {
        return this.$store.state.wallet.chosenOwner
      },
      set(payload) {
        this.$store.dispatch('setChosenOwner', payload)
      },
    },
  },

  data() {
    return { keyPix: '' }
  },

  methods: {
    selectedAccount(user) {
      this.chosenOwner = user

      !this.withdraw ? this.accountSubmit() : ''
    },

    accountSubmit() {
      this.withdraw
        ? this.$router.push({
            name: 'carteira-cadastro-pix',
            params: {
              transfer: this.$route.params.transfer,
            },
          })
        : this.$emit('user-cpf', this.chosenOwner)
    },
  },
}
</script>

<style lang="scss">
.pix-choice-user {
  padding: 20px;
  margin-top: 35px;

  &__title {
    font-size: 20px;
    line-height: 1.2;
    font-weight: bold;
    color: $gray-6;
  }

  &__subtitle {
    padding-top: 8px;
    font-size: 16px;
    line-height: 1.5;
    color: $gray-5;
  }

  &__input {
    input {
      font-size: 2rem !important;
      margin: 15px auto;
      font-weight: bold;
      color: $gray-4;
    }

    input::placeholder {
      font-size: 2rem !important;
      color: $gray-4;
    }

    .field-body {
      padding-left: 0;
    }
  }

  &__select {
    margin-top: 20px;
  }

  &__item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 24px;
    border-radius: 8px;
    border: solid 1px $gray-4;
    margin: 8px 0;
    cursor: pointer;
    @media screen and (min-width: $mobile) {
      max-width: 448px;
    }

    &:hover {
      border: solid 1px $support;
      background-color: #f6ffff;
    }

    &--bullet {
      height: 20px;
      width: 20px;
      border: solid 2px;
      border-radius: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 10px;
    }

    &--name {
      color: $gray-6;
      font-size: 16px;
      font-weight: bold;
      line-height: normal;
    }

    &--cpf {
      font-size: 14px;
      color: $gray-6;
      line-height: normal;
    }
  }

  &__item-selected {
    border: solid 1px $support;
    background-color: #f6ffff;

    .bullet-selected {
      border-color: $support;
    }

    .selected {
      width: 10px;
      height: 10px;
      background: $support;
      border-radius: 100%;
    }
  }

  &__button {
    margin-top: 50px;
  }
}
</style>
